import React from 'react';
import calendar from '../../assets/icons/calendar.svg';
import pin from '../../assets/icons/map.svg';
import './card2.css';


const Card2 = (props) => {
    return ( 
        <>
        <div className="card2">
            <img className='eventImg' src={props.eventImg} alt="card img" />
            <div className="card2Cont">
                <div className="card2Category">
                    <p className='body'>{props.eventCategory}</p>
                </div>
                <h4 className='body'>{props.eventTitle}</h4>
                <div className="card2Det">
                    <img src={calendar} alt="calendar icon" />
                    <h6 className='body'>{props.eventDate}</h6>
                </div>
                <div className="card2Det">
                    <img src={pin} alt="pin icon" />
                    <h6 className='body'>{props.eventLoc}</h6>
                </div>
                <h5 className='price body'>{props.eventPrice}</h5>
            </div>
        </div>
        </>
     );
}
 
export default Card2;